import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';

import { configSelector } from 'shared/app/shell';

import UnauthPartnershipCard from './unauth-partnership-card';
import { partnershipsMap } from './partnerships-map';

import styles from './styles.cssm';
import messages from './messages';

const Partnerships = () => {
  const { formatMessage } = useIntl();
  const config = useSelector(configSelector);

  const partnershipsList = config.partnerships || [];

  return (
    <ContentColumn
      className="sb-global-gutters--maxWidthLayout color-greenOnPrimary py4 md-py9"
      size="xl"
    >
      <div className="flex flex-column items-center text-center">
        <Heading
          className={`${styles.headingText} text-bold`}
          size="xl"
          tagName="h2"
        >
          {formatMessage(messages.header)}
        </Heading>
        <p className="color-textBodyOnPrimary text-xs mt3 mb4 md-mb5">
          {formatMessage(messages.subHeading, {
            link: (content) => (
              <Link
                className="text-semibold color-greenAccent color-interactiveLinkOnPrimary"
                to="/account/create"
              >
                {content}
              </Link>
            ),
          })}
        </p>
      </div>
      <div className={`${styles.itemsContainer} mb4`}>
        {partnershipsList.map((partnership, idx) => {
          const partnershipDetails = partnershipsMap[partnership];

          if (!partnershipDetails) return null;

          const {
            imageUrl,
            imageAlt,
            description,
            disclaimerTarget,
            learnMoreUrl,
          } = partnershipDetails;
          return (
            <UnauthPartnershipCard
              description={description}
              disclaimerTarget={disclaimerTarget}
              imageAlt={imageAlt}
              imageUrl={imageUrl}
              key={`partnership-card-${idx}`}
              learnMoreUrl={learnMoreUrl}
            />
          );
        })}
      </div>
    </ContentColumn>
  );
};

export default Partnerships;
